<template>
    <div v-if="links && links.length > 3">
        <div class="pagination d-flex">
            <template v-for="(link, key) in links">
                <div
                    v-if="link.url === null"
                    :key="'label_' + key"
                    class="btn"
                    :class="{ 'disabled': isDisabled(link) }"
                    v-html="link.label"
                ></div>
                <router-link
                    v-else
                    :key="key"
                    :to="getPageUrl(link.url)"
                    class="btn"
                    :class="{ 'active': link.active, 'disabled': isDisabled(link) }"
                    v-html="link.label"
                ></router-link>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        links: Array,
    },
    methods: {
        getPageUrl(url) {
            if (!url) return '#';
            const urlObj = new URL(url);
            let queryParams = new URLSearchParams(urlObj.search);
            const page = queryParams.get('page');
            queryParams.set('page', page);
            return '?' + queryParams.toString();
        },
        isDisabled(link) {
            return link.url === null;
        },
    },
};
</script>
<style scoped>
.pagination {
  gap: 4px;
}

.btn {
  padding: 8px 12px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #646464;
  text-align: center;
  cursor: pointer;
  transition: inherit;
  font-size: 14px;
  font-weight: 500;
}

.dark .btn {
    background-color: #2e333d;
    color: #b5b9d0;
    border-color: #2e333d;
}

.dark .btn:hover {
    background-color: #3c424f;
}

.btn:hover {
  background-color: #e0e0e0;
}

.btn.active, .btn.active:hover {
  background-color: #583a8e;
  color: #ffffff;
}

@media screen and (max-width: 765px){
    .pagination {
        width: 100%;
    }

    .btn {
        display: none !important;
    }

    .btn:first-child, .btn:last-child {
      display: block !important;
      width: 100%;
    }
}
</style>